import toast from 'react-hot-toast'
import api from './api'
import { fallback, paginate } from './fallbackData'

export const userService = {
  async addUser(data) {
    try {
      const response = await api.post('/users/add-user', data)
      console.log("Add User Response:", response);
      toast.success(response.message );

      return response
    } catch (e) {
      toast.error(e.response.data.errors || 'Failed to add user')

      // const newUser = { id: Date.now(), ...data }
      // fallback.users.push(newUser)
      // return newUser
    } 
  },
    async getAllRoles(params = {}) {
    try {
      const response = await api.post('/users/get-all-roles', { params })
      return response // { users, pagination }
    } catch (e) {
        toast.error(e.response.data.errors || 'Failed to get roles')

    }
  },
    async getUserProfile() {
    try {
      const response = await api.post('/users/user-profile')
      return response // { users, pagination }
    } catch (e) {
        toast.error(e.response.data.errors || 'Failed to get roles')

    }
  },
    async getAllSections(params = {}) {
    try {
      const response = await api.post('/users/get-sections', { params })
      return response // { users, pagination }
    } catch (e) {
        toast.error(e.response.data.errors || 'Failed to get roles')

    }
  },
      async getAllGrades(params = {}) {
    try {
      const response = await api.post('/applications/get-grades', { params })
      return response // { users, pagination }
    } catch (e) {
        toast.error(e.response.data.errors || 'Failed to get roles')

    }
  },
  async getAllUsers(params ) {
    try {
      const response = await api.post('/users/get-users', params )
      return response // { users, pagination }
    } catch (e) {
      const { items, pagination } = paginate(fallback.users, params.page || 1, params.limit || 10)
      return { users: items, pagination }
    }
  },

  async getUserById(id) {
    try {
      const response = await api.post(`/users/user-detail`,{id})
      return response.data
    } catch (e) {
      const user = fallback.users.find(u => u.id === Number(id))
      return user || fallback.demoUser
    }
  },

  async updateUser(id, userData) {
    try {
      const response = await api.put(`/users/${id}`, userData)
      return response.data
    } catch (e) {
      const existing = fallback.users.find(u => u.id === Number(id)) || fallback.demoUser
      return { ...existing, ...userData }
    }
  },

  async deleteUser(id) {

    console.log("Deleting user with ID:", id);
    
    try {
      const response = await api.post(`/users/delete-user`,id)
      return response
    } catch (e) {
      return null
    }
  },

  async getStudentsByFamily() {
    try {
      const response = await api.get('/users/family/students')
      return response.data
    } catch (e) {
      const students = fallback.users.filter(u => u.role === 'STUDENT')
      return students
    }
  }
}